<template>
 <div class="driver-container"> 
    <!-- 搜索区域 -->
    <div class="search-section">
        <van-search
            v-model="searchvalue"
            placeholder="请输入型号关键词"
            show-action
            @search="onSearch"
            @cancel="onCancel"
            class="search-box"
        >
            <template #action>
                <div @click="onSearch" class="search-action">搜索</div>
            </template>
        </van-search>
    </div>

    <!-- 驱动列表 -->
    <div class="driver-content">
        <!-- 结果统计 -->
        <div v-if="hasDrivers" class="result-count">
            <van-icon name="search" class="count-icon" />
            共找到 {{ driverlist.length }} 个驱动
        </div>

        <!-- 驱动列表 -->
        <div v-if="hasDrivers" class="drivers-container">
            <div 
                class="driver-card" 
                v-for="item in driverlist" 
                :key="item.RecID"
                @click="clickItem(item.FileURL)"
            >
                <div class="driver-header">
                    <van-icon name="description" class="driver-icon" />
                    <div class="driver-info">
                        <h4 class="driver-title">{{ item.Detail }}</h4>
                        <p class="driver-model">{{ item.model }}</p>
                    </div>
                    <van-tag type="primary" class="size-tag" v-if="item.size">
                        {{ item.size }}
                    </van-tag>
                </div>
                
                <div class="driver-footer">
                    <van-button 
                        size="small" 
                        type="primary" 
                        class="download-btn"
                    >
                        <van-icon name="down" />
                        下载驱动
                    </van-button>
                </div>
            </div>
        </div>
        <!-- 空状态 -->
        <div v-else class="empty-state">
            <van-empty description="请输入型号关键词搜索驱动" image="search">
                <van-button 
                    round 
                    type="primary" 
                    class="retry-btn"
                    @click="onSearch"
                >
                    开始搜索
                </van-button>
            </van-empty>
        </div>
    </div>
 </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import 'vant/lib/icon/local.css';
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);
import { Dialog } from 'vant';
import { Toast } from 'vant'
import global from '../../components/global.vue';

// 常量定义
const API_BASE_URL = 'https://t3.lenovoimage.com/api/Web/getProductDriverbyKeyWord?KeyWord=';
const MESSAGES = {
  NO_KEYWORD: '请输入搜索关键词',
  NO_DRIVERS_FOUND: '未找到相关驱动',
  SEARCH_FAILED: '搜索失败，请重试',
  COPY_SUCCESS: '链接已复制到剪贴板！'
};

export default {
  name: 'DRIVER',
  data() {
    return {		
      driverlist: [],			
      searchvalue: '',
      keyword: '',
      sn: '',
      Driver: require("@/assets/driver2.png"),
    }
  },
  
  computed: {
    /**
     * 检查是否有驱动数据
     */
    hasDrivers() {
      return this.driverlist && this.driverlist.length > 0;
    }
  },
  
  created() {        
    console.log(global.devicesList, 'global.devicesList');
    this.initDefaultSearch();
  },
  
  mounted() {
    document.title = "驱动下载";
  },
  
  methods: {		
    /**
     * 初始化默认搜索
     */
    initDefaultSearch() {
      if (global.devicesList && global.devicesList.length > 0) {                   
        const model = global.devicesList[0].Model;
        this.searchvalue = model;
        this.getdriverlist(model);
      }
    },
    
    /**
     * 搜索处理
     */
    onSearch() {
      const keyword = this.searchvalue.trim();
      
      if (!keyword) {
        Toast(MESSAGES.NO_KEYWORD);
        return;
      }
      
      this.getdriverlist(keyword);		  
    },
    
    /**
     * 取消搜索
     */
    onCancel() {
      this.driverlist = [];
      this.searchvalue = '';
    },
    
    /**
     * 获取驱动列表
     * @param {string} keyword - 搜索关键词
     */
    getdriverlist(keyword) {
      console.log("搜索关键词", keyword);
      
      Vue.axios.get(`${API_BASE_URL}${keyword}`)
        .then(response => {
          this.handleDriverResponse(response);
        })
        .catch(error => {
          this.handleDriverError(error);
        });					
    },
    
    /**
     * 处理驱动列表响应
     * @param {Object} response - API响应
     */
    handleDriverResponse(response) {
      console.log('API响应:', response);
      this.driverlist = response.data.Data || [];
      console.log('驱动列表:', this.driverlist);
      
      if (this.driverlist.length === 0) {
        Toast(MESSAGES.NO_DRIVERS_FOUND);
      }
    },
    
    /**
     * 处理驱动列表错误
     * @param {Object} error - 错误对象
     */
    handleDriverError(error) {
      console.log('API错误:', error);
      this.driverlist = [];
      Toast(MESSAGES.SEARCH_FAILED);
    },
    
    /**
     * 处理驱动项点击
     * @param {string} url - 下载链接
     */
    clickItem(url) {		
      Dialog.confirm({
        title: '温馨提示',
        message: '驱动固件文件尺寸较大，推荐您可以粘贴地址使用PC下载',
        confirmButtonText: '直接下载',
        cancelButtonText: '拷贝链接',
        showCancelButton: true
      }).then(() => {
        // 确认 - 直接下载
        window.location.href = url;
      }).catch(() => {
        // 取消 - 拷贝链接
        this.copyDownloadLink(url);
      });
    },
    
    /**
     * 复制下载链接
     * @param {string} url - 下载链接
     */
    copyDownloadLink(url) {
      this.$copyText(url);
      Toast({
        message: MESSAGES.COPY_SUCCESS,
        icon: 'passed'
      });
    }
  }
}
</script>

<style scoped>
.driver-container {
    background-color: #f7f8fa;
    min-height: 100vh;
}

.header-image {
    width: 100%;
    height: auto;
    overflow: hidden;
}

.search-section {
    background-color: #ffffff;
    padding: 16px;
    border-bottom: 1px solid #f0f0f0;
}

.search-box {
    padding: 0;
    border-radius: 8px;
    overflow: hidden;
}

.search-action {
    color: #1989fa;
    font-size: 14px;
    padding: 0 8px;
}

.driver-content {
    padding: 16px;
    background-color: #f7f8fa;
    min-height: 50vh;
}

.result-count {
    background-color: #e6f7ff;
    border: 1px solid #91d5ff;
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
}

.count-icon {
    margin-right: 8px;
    font-size: 16px;
}

.drivers-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.driver-card {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    border: 1px solid #f0f0f0;
    transition: all 0.3s ease;
    cursor: pointer;
}

.driver-card:active {
    background-color: #f5f5f5;
    transform: scale(0.98);
}

.driver-header {
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;
}

.driver-icon {
    color: #1989fa;
    font-size: 20px;
    margin-right: 12px;
    margin-top: 2px;
    flex-shrink: 0;
}

.driver-info {
    flex: 1;
    min-width: 0;
}

.driver-title {
    font-size: 15px;
    font-weight: bold;
    color: #323233;
    margin-bottom: 4px;
    line-height: 1.4;
    word-break: break-all;
}

.driver-model {
    font-size: 13px;
    color: #969799;
    margin: 0;
}

.size-tag {
    margin-left: 8px;
    flex-shrink: 0;
}

.driver-footer {
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid #f5f5f5;
    padding-top: 12px;
}

.download-btn {
    border-radius: 16px;
    font-size: 12px;
}

.empty-state {
    padding: 40px 20px;
}

.retry-btn {
    margin-top: 16px;
}
</style>